import React from 'react'
import type { PresentationBlock, QuoteFile } from 'paintscout'

import { ButtonSelectOption, ButtonOption } from '../../components'
import { appendGalleryFiles } from './galleryFiles'

import LooksOneIcon from '@material-ui/icons/LooksOne'
import LooksTwoIcon from '@material-ui/icons/LooksTwo'
import Looks3Icon from '@material-ui/icons/Looks3'
import Looks4Icon from '@material-ui/icons/Looks4'
import AppsIcon from '@material-ui/icons/Apps'
import AddIcon from '@material-ui/icons/Add'

interface GalleryOptionsProps {
  block: PresentationBlock
  handleOptionFieldChange: (field: string, value: any) => void
  /**
   * Opens the Library dialog in multi-select mode (#23709). Supplied by the inspector, which can
   * use hooks; when it's missing the button falls back to appending one empty slot, which is what
   * it did before multi-select existed.
   */
  openMediaLibrary?: (args: { onSelect: (files: QuoteFile[]) => void }) => void
}

function GalleryOptions(props: GalleryOptionsProps) {
  const { block, handleOptionFieldChange, openMediaLibrary } = props
  const { columns, files } = block.fields

  const handleAddFiles = (newFiles: QuoteFile[]) => {
    const updated = appendGalleryFiles(files, newFiles)
    if (updated === files) return
    handleOptionFieldChange('fields.files', updated)
  }

  const handleNewFile = () => {
    if (openMediaLibrary) {
      openMediaLibrary({ onSelect: handleAddFiles })
      return
    }

    const newFiles = [...files]
    newFiles.push({ tempKey: 'tempKey' + new Date().getTime(), type: 'upload' })
    handleOptionFieldChange('fields.files', newFiles)
  }

  const options = [
    {
      Component: (
        <ButtonSelectOption
          label={'Columns'}
          value={columns}
          buttons={[
            { icon: <AppsIcon />, value: 'auto' },
            { icon: <LooksOneIcon />, value: 1 },
            { icon: <LooksTwoIcon />, value: 2 },
            { icon: <Looks3Icon />, value: 3 },
            { icon: <Looks4Icon />, value: 4 }
          ]}
          onChange={(value) => handleOptionFieldChange('fields.columns', value)}
        />
      ),
      tab: 'content'
    },
    {
      Component: <ButtonOption label={'Add Item(s)'} buttons={[{ icon: <AddIcon />, onClick: handleNewFile }]} />,
      tab: 'content'
    }
  ]

  return options
}

export default GalleryOptions
